export default __webpack_public_path__ + "static/kelowna2-dec2787bb433c80fe5b427a183877d0c.jpg";